import Popover from 'antd/es/popover';
import 'antd/es/popover/style/css';

export default Popover;
